import { memo, useMemo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { BzTab, BzTabs } from "../../components";
import { setBIsGridDataShow, setSelectedTab } from "../../redux/actions/screeners";
import { LOCATIONS, SCREENERS_TABS } from "../../utils/global_variables";

const ScreenersHeaderTabs = ({ isExpandCollapse, handleBack, ...props }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const selectedTab = useSelector(state => state.screeners.selectedTab);

    const handleTabs = (tabKey) => {
        dispatch(setSelectedTab(tabKey));
        dispatch(setBIsGridDataShow(false));
    };

    const arrScreenersTabs = useMemo(() => [
        {
            id: '0',
            title: 'Strategy',
            tabKey: SCREENERS_TABS.STRATERGY,

        },
        {
            id: '1',
            title: 'Scanners',
            tabKey: SCREENERS_TABS.SCANNERS,
        },
        {
            id: '2',
            title: 'My Favourites',
            tabKey: SCREENERS_TABS.MY_FAVOURITES,
        },

    ], []);
    return (
        <>

            {(location?.pathname === LOCATIONS.DASHBOARD) ?
                <>
                    <div className='horizontal-scroll-wrap d-flex justify-content-center text-center pt-2'>
                        <BzTabs className='nav nav-tabs'>
                            {arrScreenersTabs?.length > 0 && arrScreenersTabs?.map((each) => (
                                <BzTab key={each.id} onClick={handleTabs.bind(this, each?.tabKey)} className='nav-link text-capitalize' isActive={each.tabKey === selectedTab} tabKey={each.tabKey}>{each.title}</BzTab>
                            ))}
                        </BzTabs>
                    </div>
                </>
                :
                <>
                    <Container fluid className='p-0'>
                        <Row className='g-0 mt-2 px-3'>
                            <Col md='auto' className='d-flex justify-content-start align-items-center'>
                                {(isExpandCollapse) ? <div className='icon-16 icon-dark icon-backward-arrow me-3' onClick={() => { handleBack(); }}></div> : null}
                            </Col>
                            <Col className='d-flex justify-content-center align-items-center'>
                                <div className='horizontal-scroll-wrap'>
                                    <BzTabs className='nav nav-tabs'>
                                        {arrScreenersTabs?.length > 0 && arrScreenersTabs?.map((each) => (
                                            <BzTab key={each.id} onClick={handleTabs.bind(this, each?.tabKey)} className='nav-link text-capitalize' isActive={each.tabKey === selectedTab} tabKey={each.tabKey}>{each.title}</BzTab>
                                        ))}
                                    </BzTabs>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </>
            }

        </>
    );
};
export default memo(ScreenersHeaderTabs);